import { render, staticRenderFns } from "./layoutStudent.vue?vue&type=template&id=bb01240e&"
import script from "./layoutStudent.vue?vue&type=script&lang=js&"
export * from "./layoutStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports